@use "variables" as *;

.noItemsStack {
  display: flex;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
}

.noItemsIcon {
  font-size: $fontSize-xxg !important;
  margin-bottom: $spacing-m !important;
}

.noItems {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: center;
}

.noItemsSubtitle {
  font-size: $fontSize-s;
  font-weight: normal;
  text-align: center;
}

.addButton {
  margin: $spacing-xxl !important;
  flex-grow: 0 !important;
}
